import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WorkerApp } from './worker/WorkerApp';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/worker/*" element={<WorkerApp />} />
          <Route path="/" element={
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-2xl font-bold text-gray-900 mb-4">
                  BTP Worker
                </h1>
                <p className="text-gray-600">
                  Accédez à votre chantier avec votre token d'accès
                </p>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;